import { useState, useRef } from "react";
import Config from "../../Config";


import PlTitle from "../../elements/PlTitle";
import InputPagger from "../../helpers/InputPagger";

import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputCombo from "../../helpers/InputCombo";
import InputLegend from "../../helpers/InputLegend";
import InputComboGrupa from "../../helpers/InputComboGrupa";

import InputComboRok from "../../helpers/InputComboRok";
import InputComboMiesiac from "../../helpers/InputComboMiesiac";


import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import HtmlToPDF from "../../exporter/HtmlToPDF";

import trash from "../../trash.png";
import gin from "../../gin.png";
import gout from "../../gout.png";
import InOutNew from "./InOutNew";


import XTime from "./XTime";
import XTimeByDay from "./XTimeByDay";
import X2Time from "./X2Time";
import InputComboDzien from "../../helpers/InputComboDzien";
import MenuTable from "../../helpers/MenuTable";
import AppContext from "../../AppContext";
import SortBy from "../../helpers/SortBy";
import NoRegister from "./NoRegister";
import Xlsx from "../../exporter/Xlsx";



function InOut(props)
{

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);

    const tabRef = useRef(0);
    const tab2Ref = useRef(0);


    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({
        d_imie_nazwisko: props.mainView.readFilter('d_imie_nazwisko',''),          
        p_grupa_id: props.mainView.readFilter('p_grupa_id','_x_'),
        operacja: '_x_',
        rok: (new Date()).getFullYear() ,
        miesiac: (new Date() ).getMonth()+1,           
        archiwalne: "0",
        dzien: '_x_',           
        limit: 50,
        page: 1,
        pages: 1,
        show: true,

        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },

    });
    const [tab, setTab] = useState(null);

    const [selectedRow, setSelectedRow] = useState([]);

    const [view, setView] = useState ( {
        v:'list',
        id: -1
    } );


      const [optionArch, setOptionArch]  = useState([
        {
            v: '_x_',
            title: ' - - - '
        },
        {
            v: '0',
            title: 'Dziecko aktywne'
        }, {
            v: '1',
            title: 'Dziecko w archiwum'
        }
    ]
    );



    const [legend, setLegend] = useState([
        {
            cls:'color_show1',
            title: 'Wejście lub wyjście wirtualne - systemowe',
       
        },
    ]);




    const [gr, setGr] = useState([]);
    const fetchGr = (fTab) => {   setGr(fTab);  }

        //-------------------------------------------------------
//-------------------------------------------------------
//MASS
const changeSelected = (e) => {

    var id    = e.target.getAttribute('atr-id');   
    var selected = 0;

    if(e.target.checked) selected = 1;

    for(var k=0; k<selectedRow.length; k++)
    {
        if(selectedRow[k].id == id)  selectedRow[k].selected = selected;
    }

    setSelectedRow(  JSON.parse(JSON.stringify(selectedRow) ) );    
}

const changeSelectedAll = (e) => {

    var s = selectedRow[0].selected;
    if(s == 1) {  s = 0; } else s = 1;

    for(var k=0; k<selectedRow.length; k++)
        {
          selectedRow[k].selected = s;
        }
    
        setSelectedRow(  JSON.parse(JSON.stringify(selectedRow) ) ); 

}


//-------------------------------------------------------
//-------------------------------------------------------





    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_kids,inout', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);            
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );       
                        
                        var newSelector = [];

                        res.result.forEach( (item) => {
                            newSelector.push({
                                id: item.id,
                                title: item.imie  + "  " + item.nazwisko,
                                selected: 0,
                            });
                        } )

                        setSelectedRow(newSelector);


                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }

  

    const valChangeListener = (filedName, val, correct, msg) => {

       // console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
        
        if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }

        props.mainView.writeFilter(filedName, val);
    }


    const goNextNew = () => {
        console.log("goNext");    
        setTab(null);    
    }


    const filterView = () => {
        setFilterParam(  {...filterParam, ["show"]:!filterParam.show } );
    }



    const filterClear = () => {
        setFilterParam({
            d_imie_nazwisko: '', 
            
            p_grupa_id: '_x_', 
            operacja: '_x_',
            rok: (new Date()).getFullYear() ,
            miesiac: (new Date() ).getMonth()+1,  
            dzien: '_x_',   
            archiwalne: "0",         
            limit: 50,
            page: 1,
            pages: 1,
            show: true,

            sortBy: {
                sort:  "", //asc desc,
                column: "",
            },
        });
        setTab(null);

        props.mainView.writeFilter('d_imie_nazwisko', '');
      
        props.mainView.writeFilter('p_group_id', '_x_'); 
    }

    const filterApprove = () => {   
        setTab(null)     
    }

    const onChangePagger = (x_limit, x_page) => {

        setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
        setTab(null);
    }


    const onChangeSortBy = (sortBy) => {

        setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
        setTab(null);
    }





    const goDeleteOK = (id) => {
       
 
        props.mainView.setProgress(-2);

        var req = {
            id:id
        };

        fetch( Config.url + '/rest_v1_kids,inout_remove', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                       props.mainView.showDialog( "Sukces",  "Pozycja została usunięta" , "ok" , null);  
                       getTab();  
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }



       const goChange = (e) => {

        var id = e.target.getAttribute("id");

        props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz zmienić typ zdarzenia na przeciwny?", "yesno", (option)=>{
          
                        ///--------
                        if(option == "yes") 
                        {
                                       props.mainView.setProgress(-2);

                                        var req = {
                                            id:id
                                        };

                                        fetch( Config.url + '/rest_v1_kids,inout_change_t', {
                                            method: 'POST', 
                                            body: JSON.stringify(req), 
                                            headers: {
                                                'Content-Type': 'application/json',                    
                                                'X-Api-Key': props.userData.apiKey,
                                                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                                '_p_dziecko_id_': props.userData.p_dziecko_id,
                                                '_sec_key_': Config.genXKey() ,
                                            }
                                        })
                                        .then(res => res.json() )
                                        .then(res => { 

                                                    props.mainView.setProgress(-1);        
                                                    if(res._sys_ == undefined)
                                                    {
                                                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                                    }else
                                                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                    {
                                                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                                    }else    
                                                    {
                                                    props.mainView.showDialog( "Sukces",  "Typ zdarzenia został zmieniony" , "ok" , null);  
                                                    getTab();  
                                                    }
                                        } )
                                        .catch(err => {          
                                                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                                    props.mainView.setProgress(-1);
                                        });
                        }
                        //--------
        } );
    }



    const goDelete = (e) => {

        var id = e.target.getAttribute("id");

        props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz usunąć wybraną pozycje?", "yesno", (option)=>{
          
                        ///--------
                        if(option == "yes") goDeleteOK(id);
                        //--------
        } );
    }





//param1={row.id} param2={row.dzien}  param3='' param4=''
    const onChangeXTime = (hm, param1, param2, param3, param4) =>  {

        console.log("XTime ", hm, param1, param2, param3, param4);


        props.mainView.setProgress(-2);

       
        var req = {
            p_rejestr_id: param1,
            dzien: param2,
            hm: hm,            
        };


        fetch( Config.url + '/rest_v1_kids,inout_update', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.showDialog( "Sukces",  "Zmiany zostały zapisane" , "ok" , null );
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });


    }


    const onChangeXTime2 = (hm, param1, param2, param3, param4) =>  {

        console.log("XTime ", hm, param1, param2, param3, param4);


        var ids = new Array();
                
        for(var k=0; k<selectedRow.length; k++)
            {
               if( selectedRow[k].selected == 1)
               {
                    ids.push({
                        id: selectedRow[k].id,
                        title: selectedRow[k].title
                    });
               }
            }
        
    
         if(ids.length < 1)     
         {       
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie wybrano żadnego dziecka' ,  "ok"  ,null); 
            return;              
         }




        props.mainView.setProgress(-2);

       
        var req = {
            ids: ids,       
            hm: hm,            
        };


        fetch( Config.url + '/rest_v1_kids,inout_update_mass', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.showDialog( "Sukces",  "Zmiany zostały zapisane" , "ok" , null );
                        getTab();
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });


    }
    

    

    const changeView = (e ) => {
        var v = e.target.getAttribute('v');
        var id = e.target.getAttribute('id');

        setView({...view, ["v"]:v, ["id"]:id });
    }


    const onBack = ( ) => {                
        setView({...view, ["v"]:"list", ["id"]:-1 });       
        getTab();
    }




    
    if(tab == null)
        {
            setTab([]);
            getTab();
         
    
            return <div>
                ...
            </div>
        }
    
    
        if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setTab(null);
            setView( {
                v:'list',
                id: -1
            });
        }



    var operacjaItem = [
        {
            v: '_x_',
            title: '- - -'
        },
        {
            v: 'I',
            title: 'Wejście'
        },
        {
            v: 'O',
            title: 'Wyjście'
        },
    ];




    var sortList = [                         
        {column: "dziecko_nazwisko", name: "Nazwisko"  },
]



    
    var zaznaczonych = 0;
    for(var s=0; s<selectedRow.length; s++)
    {
        if(selectedRow[s].selected == 1) zaznaczonych ++;
    }


    var titleRaport = "Wejścia i wyjścia ";
    if(filterParam.rok != '_x_') titleRaport += " " + filterParam.rok;
    if(filterParam.miesiac != '_x_') titleRaport += "-" + filterParam.miesiac;
    if(filterParam.dzien != '_x_')titleRaport += "-" + filterParam.dzien;

    if(filterParam.p_grupa_id != '_x_') 
    {
        for(var p=0; p < gr.length; p++)
        {
            if(gr[p].v == filterParam.p_grupa_id)
            {
                titleRaport += " " + gr[p].title;
                break;
            }
        }
    }else  titleRaport += " wszystkie grupy" ;

  
    document.title = titleRaport;


 


    return (

        <div className="view_content">



                {
                    filterParam.show == false  &&
                    <div className="  goright link_color" onClick={filterView}>
                        pokaż filtry
                    </div>
                } 


                {
                    filterParam.show == true  &&
                    <div className="table_filter">


                    <div className="filter_controll">   
                            <label>Rok: </label>                             
                            <InputComboRok   userData={props.userData}  mainView={props.mainView}  value={filterParam.rok}   valChange={valChangeListener} goNext={goNextNew} name="rok" placeholder={": "}  noempty="1"   />
                    </div> 
    
                    <div className="filter_controll">   
                            <label>Miesiąc: </label>                             
                            <InputComboMiesiac   userData={props.userData}  mainView={props.mainView}  value={filterParam.miesiac}   valChange={valChangeListener} goNext={goNextNew} name="miesiac" placeholder={": "}  noempty="1"   />
                    </div>
    
                    <div className="filter_controll">   
                            <label>Dzień: </label>                             
                            <InputComboDzien   userData={props.userData}  mainView={props.mainView}  rok={filterParam.rok}  miesiac={filterParam.miesiac}  value={filterParam.dzien}   valChange={valChangeListener} goNext={goNextNew} name="dzien" placeholder={": "}  noempty="0"   />
                    </div>
    
                    <div className="filter_controll">   
                            <label>Typ: </label>                             
                            <InputCombo   userData={props.userData}  mainView={props.mainView}  items={operacjaItem} value={filterParam.operacja}   valChange={valChangeListener} goNext={goNextNew} name="operacja" placeholder={": "}  noempty="1"   />
                    </div>
    
    
                    <div className="filter_controll">   
                        <label>Grupa: </label>                             
                        <InputComboGrupa   userData={props.userData}  mainView={props.mainView}  value={filterParam.p_grupa_id} fetchTab={fetchGr}  valChange={valChangeListener} goNext={goNextNew} name="p_grupa_id" placeholder={"Grupa: "}   />
                    </div> 
    
    
                    <div className="filter_controll">   
                        <label>Dziecko: </label>                             
                        <InputTextAlpha   userData={props.userData} value={filterParam.d_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="d_imie_nazwisko" placeholder={"Dziecko: "}   />
                    </div>  


                       <div className="filter_controll">   
                                    <label>Archiwum: </label>                             
                                    <InputCombo   userData={props.userData} value={filterParam.archiwalne} items={optionArch}  valChange={valChangeListener} goNext={goNextNew} name="archiwalne" placeholder={"Archiwalne: "}   />
                            </div> 
    
               
                    <div className="filter_btn">
                                    <span className="link_color" onClick={filterView}>&nbsp;ukryj filtry&nbsp;</span> 
                                    <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                    </div>
    
                </div>
                } 

         
         



            <div className="table_widget">

                            <InOutNew userData={props.userData} mainView={props.mainView}  onSuccess={getTab} />                 

                            <NoRegister   userData={props.userData} mainView={props.mainView}  onSuccess={getTab}  />                                 
 

                            <InputPagger filter={filterParam}  onChange={onChangePagger}  />
                                
                            <InputLegend items={legend} />

                            &nbsp;&nbsp;                              

                            <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title={titleRaport  } />   

                            <Csv tabRef={tab2Ref} title={ titleRaport + ".csv" } />
                            <Xlsx tabRef={tab2Ref} title={ titleRaport  + ".xlsx" } />
                  
                            <Print tabRef={tab2Ref}  title={titleRaport} />

                            <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />  
            </div>



            <div className="table_mass">  
                                    <div className="title_mass">Operacje masowe (zaznaczono: {zaznaczonych}) </div>
                                    &nbsp;
                                    <X2Time title={ "Zmień dla wybranych pozycji ("  + zaznaczonych + ")" }   mainView={props.mainView} onChange={onChangeXTime2} param1={zaznaczonych} param2={1}  param3={1} param4='' />                                                            
            </div>


            <div className="bg_center">

 

                            <div ref={tabRef} className="gohide">

                                    <h3>{titleRaport}</h3>   

                                    <table className="table" ref={tab2Ref}>
                                        <thead>
                                            <tr className="header">
                                                <td>LP</td>     
                                                                                         
                                                <td>Dziecko</td>    
                                                <td>Typ</td>                                   
                                                <td>Dzień</td> 
                                                <td>Godzina</td> 
                                                <td>Źródło / Karta / Osoba</td>
                                         
                                            </tr>
                                        </thead>


                                        <tbody>
                                                        {
                                                            tab.map( (row, ix)=>{

                                                                var opTxt = "Wejście";
                                                                if(row.operacja == 'O') opTxt = "Wyjście";


                                                                var cls = "";
                                                                if(row.autododanie == '1') cls = "color_show1";


                                                               

                                                                return <tr className={cls} key={"x"+ix}>
                                                                    <td>{ix+1}</td>


                                                                    

                                                                    <td>{row.nazwisko + " " + row.imie}</td>
                                                                    <td className="gocenter">{opTxt}</td>
                                                                    <td className="gocenter">{row.dzien}</td>
                                                                    <td className="gocenter">{row.godzina}</td>
                                                                    <td>{row.src.info}</td>                                                              
                                                                </tr>
                                                            } )
                                                        }    
                                        </tbody>
                                        
                                    </table>
                            </div>

                <div className="scorll_x">
                            <table className="table" >
                                <thead>
                                    <tr className="header">
                                        <td className="td_left">LP</td>     
                                        <td className="link_normal" onClick={changeSelectedAll}>Z</td>                                                
                                        <td>Czas sys.</td>    
                                        <td>Dziecko</td>    
                                        <td>Typ</td>                                   
                                        <td>Dzień</td> 
                                        <td>Godzina</td> 
                                        <td className="td_right">Źródło / Karta / Osoba</td>
                                        <td className="td_option"> </td>
                                    </tr>
                                </thead>


                                <tbody>
                                                {
                                                    tab.map( (row, ix)=>{

                                                        var imgType = <img className="ibtn" src={gin} title="wejście"   />;
                                                        var opTxt   = "Wejście";

                                                        if(row.operacja == 'O') 
                                                            {
                                                               opTxt = "Wyjście";
                                                               imgType = <img className="ibtn" src={gout} title="wyjście"   />;
                                                            }


                                                        var cls = "";
                                                        if(row.autododanie == '1') cls = "color_show1";

                                                        var sp = row.godzina.split(":");


                                                        var isChecked = "";

                                                        for(var s=0; s<selectedRow.length; s++)
                                                            {
                                                                if( selectedRow[s].id == row.id &&  selectedRow[s].selected == 1) isChecked = "checked";
                                                            }

                                                            

                                                            var rowStyle = " row ";
                                                            if(ix % 2 == 0 )rowStyle = " row2 ";

                                                        return <tr className={ rowStyle + cls} key={ix+1}>
                                                            <td className="gocenter">{ix+1}</td>

                                                            <td className="gocenter">
                                                                 <input type="checkbox" atr-id={row.id} onChange={changeSelected} checked={isChecked} />
                                                            </td>  

                                                            <td className="gocenter">{row.sys}</td>
                                                            <td>{row.nazwisko + " " + row.imie}</td>
                                                            <td className="gocenter">{opTxt} {imgType}     <sup title="zmień rodzaj zdarzenia" className="link_color" onClick={goChange} v="change" id={row.id} >[z]</sup>   </td>
                                                            <td className="gocenter">{row.dzien}   </td>
                                                            <td className="gocenter link_normal">
                                                                 <XTime title={ row.imie + " " + row.nazwisko + " - " + row.dzien } hour={sp[0]} minute={sp[1]}  onChange={onChangeXTime} param1={row.id} param2={row.dzien}  param3='' param4='' />                                                                                     
                                                            </td>
                                                            <td>{row.src.info}</td>

                                                           

                                                            <MenuTable>
                                                                        <ul>                                                                        
                                                                            <li onClick={goDelete} v="delete" id={row.id} >usuń</li> 
                                                                        </ul>
                                                            </MenuTable>

                                                        </tr>
                                                    } )
                                                }    
                                </tbody>
                                
                            </table>
                </div>

            </div>


        </div>
    )
}


export default InOut;